import { IOptionModel } from "@/interfaces/iPageModel";
import { GlobalFilterApi } from "@/services/api/GlobalFilter.service";
import store from "@/store";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import {
  FETCH_ALL_SITES,
  GET_ALL_SITES,
  GET_SELECTED_SITES,
  GET_SELECTED_SITES_STR,
  SET_ALL_SITES,
  SET_SELECTED_SITES,
  SITE_STORE,
  USER_SELECTED_SITES,
  RESET_USER_SELECTED_SITES,
} from "./types";

@Module({
  name: SITE_STORE,
  namespaced: true,
  dynamic: true,
  store,
})
export default class UserSite extends VuexModule {
  AVAILABLE_SITES: Array<IOptionModel> = [];
  SELECTED_SITES: Array<IOptionModel> = [];

  get [GET_ALL_SITES](): Array<IOptionModel> {
    return this.AVAILABLE_SITES;
  }
  get [GET_SELECTED_SITES](): Array<IOptionModel> {
    return this.SELECTED_SITES;
  }
  get [GET_SELECTED_SITES_STR](): string | null {
    return this.SELECTED_SITES.map((site) => site.value).join(",") || null;
  }
  @Mutation
  [SET_ALL_SITES](sites: Array<IOptionModel>) {
    this.AVAILABLE_SITES = sites;
  }
  @Mutation
  [SET_SELECTED_SITES](sites: Array<IOptionModel>) {
    this.SELECTED_SITES = sites;
  }
  @Action
  async [FETCH_ALL_SITES]() {
    const data = await GlobalFilterApi.getInstance().getSiteList();
    this.context.commit(SET_ALL_SITES, data);
  }
  @Action
  [USER_SELECTED_SITES](payload: Array<IOptionModel>) {
    this.context.commit(SET_SELECTED_SITES, payload);
  }
  @Action
  [RESET_USER_SELECTED_SITES]() {
    this.context.commit(SET_SELECTED_SITES, []);
  }
}
